import React, { useState, useEffect } from 'react'
import Sidebar from '../mini-comp/Sidebar'
import Topbar from '../mini-comp/Topbar'
import axios from 'axios';
import Cookies from 'js-cookie';
import API_BASE_URL from '../../../config/api';
import { FaUsers, FaUserPlus, FaUserCheck, FaUserMinus, FaUserTimes, FaUserCog, FaSitemap, FaCalendarCheck, FaBell } from 'react-icons/fa'
import { RiEyeLine } from 'react-icons/ri'

const HRDashboard = () => {
    const [totalEmployees, setTotalEmployees] = useState(0);
    const [totalImmediateManagers, setTotalImmediateManagers] = useState(0);
    const [totalEmployeesOnLeave, setTotalEmployeesOnLeave] = useState(0);
    const [totalEmployeesSuspended, setTotalEmployeesSuspended] = useState(0);
    const [totalEmployeesTerminated, setTotalEmployeesTerminated] = useState(0);
    const [totalDepartments, setTotalDepartments] = useState(0);
    const [totalHolidays, setTotalHolidays] = useState(0);
    const [nextHoliday, setNextHoliday] = useState({});
    const [recentlyAddedEmployees, setRecentlyAddedEmployees] = useState([]);
    const [recentNotices, setRecentNotices] = useState([]);
    const [totalSalaryWage, setTotalSalaryWage] = useState(0);
    const [totalVacationLeaveDays, setTotalVacationLeaveDays] = useState(0);
    const [totalCashInLieuOfLeave, setTotalCashInLieuOfLeave] = useState(0);
    const [recentLeaves, setRecentLeaves] = useState([]);
    const [ytdRecruitment, setYtdRecruitment] = useState(0);
    const [terminationsThisMonth, setTerminationsThisMonth] = useState(0);
    const [ytdTerminations, setYtdTerminations] = useState(0);
    const [recruitmentThisMonth, setRecruitmentThisMonth] = useState(0);
    const [dashboardData, setDashboardData] = useState(null);

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        return date.toLocaleDateString(undefined, options);
    };

    const formatCurrency = (amount) => {
        const num = parseFloat(amount);
        if (isNaN(num)) return '0.00';
        return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const getStatusBadgeClass = (status) => {
        switch (status?.toLowerCase()) {
            case 'approved': return 'bg-label-success';
            case 'rejected': return 'bg-label-danger';
            case 'pending': return 'bg-label-warning';
            case 'in_review': case 'in review': return 'bg-label-info';
            default: return 'bg-label-primary';
        }
    };

    useEffect(() => {
        const token = Cookies.get('token');

        if (!token) {
            console.error('No token found in cookies');
            return;
        }

        axios.get(`${API_BASE_URL}/api/v1/employees/hr-dashboard/`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => {
                console.log('HR Dashboard Data:', response.data);
                const data = response.data || {};
                setTotalEmployees(data.total_employees || 0);
                setTotalImmediateManagers(data.total_immediate_managers || 0);
                setTotalEmployeesOnLeave(data.total_employees_on_leave || 0);
                setTotalEmployeesSuspended(data.total_employees_suspended || 0);
                setTotalEmployeesTerminated(data.total_employees_terminated || 0);
                setTotalDepartments(data.total_departments || 0);
                setRecentlyAddedEmployees(data.recently_added_employees || []);
                setTotalHolidays(data.total_holidays || 0);
                setNextHoliday(data.next_holiday || {});
                setRecentNotices(data.recent_notices || []);
                setTotalSalaryWage(data.total_salary_wage || 0);
                setTotalVacationLeaveDays(data.total_vacation_leave_days || 0);
                setTotalCashInLieuOfLeave(data.total_cash_in_lieu_of_leave || 0);
                setRecentLeaves(data.recent_leaves || []);
                setYtdRecruitment(data.ytd_recruitment || 0);
                setTerminationsThisMonth(data.terminations_this_month || 0);
                setYtdTerminations(data.ytd_terminations || 0);
                setRecruitmentThisMonth(data.recruitment_this_month || 0);
                setDashboardData(data);
            })
            .catch(error => {
                console.error('Error fetching admin dashboard data:', error);
            });
    }, []);

    return (
        <div>
            <Topbar />
            <Sidebar />

            <>{ /* app-content-area-start */}
                <div className="app-content-area">
                    <div className="app-content-wrap">
                        <div className="container-fluid">
                            <div className="row fix">
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body mini-card-body d-flex align-center gap-16">
                                            <div className="avatar avatar-xl bg-primary-transparent text-primary">
                                                <FaUsers />
                                            </div>
                                            <div className="card-content">
                                                <span className="d-block fs-16 mb-5">Total Employees</span>
                                                <h2 className="mb-5">{totalEmployees}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                               
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body mini-card-body d-flex align-center gap-16">
                                            <div className="avatar avatar-xl bg-primary-transparent text-primary">
                                                <FaSitemap />
                                            </div>
                                            <div className="card-content">
                                                <span className="d-block fs-16 mb-5">Total Departments</span>
                                                <h2 className="mb-5">{totalDepartments}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                 <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body mini-card-body d-flex align-center gap-16">
                                            <div className="avatar avatar-xl bg-secondary-transparent text-secondary">
                                                <FaUserCog />
                                            </div>
                                            <div className="card-content">
                                                <span className="d-block fs-16 mb-5">Total Salaries Wage</span>
                                                <h2 className="mb-5">${formatCurrency(totalSalaryWage)}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body mini-card-body d-flex align-center gap-16">
                                            <div className="avatar avatar-xl bg-secondary-transparent text-secondary">
                                                <FaCalendarCheck />
                                            </div>
                                            <div className="card-content w-100">
                                                <span className="d-block fs-16 mb-5">Leaves & CILL</span>
                                                <div className="d-flex align-items-center justify-content-between gap-10">
                                                    <div>
                                                        <span className="d-block fs-12 text-muted">Total Leaves</span>
                                                        <h4 className="mb-0 fw-bold">{totalVacationLeaveDays} <span className="fs-12 text-muted fw-normal">days</span></h4>
                                                    </div>
                                                    <div className="border-start ps-10">
                                                        <span className="d-block fs-12 text-muted">Total CILL</span>
                                                        <h4 className="mb-0 fw-bold text-primary">${formatCurrency(totalCashInLieuOfLeave)}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Row 2: Recruitment & Terminations Row */}
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body mini-card-body d-flex align-center gap-16">
                                            <div className="avatar avatar-xl bg-success-transparent text-success">
                                                <FaUserPlus />
                                            </div>
                                            <div className="card-content">
                                                <span className="d-block fs-16 mb-5">Recruited (This Month)</span>
                                                <h2 className="mb-5 text-success">{recruitmentThisMonth}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body mini-card-body d-flex align-center gap-16">
                                            <div className="avatar avatar-xl bg-primary-transparent text-primary">
                                                <FaUserCheck />
                                            </div>
                                            <div className="card-content">
                                                <span className="d-block fs-16 mb-5">YTD Recruited</span>
                                                <h2 className="mb-5 text-primary">{ytdRecruitment}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body mini-card-body d-flex align-center gap-16">
                                            <div className="avatar avatar-xl bg-warning-transparent text-warning">
                                                <FaUserMinus />
                                            </div>
                                            <div className="card-content">
                                                <span className="d-block fs-16 mb-5">Terminated (This Month)</span>
                                                <h2 className="mb-5 text-warning">{terminationsThisMonth}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body mini-card-body d-flex align-center gap-16">
                                            <div className="avatar avatar-xl bg-danger-transparent text-danger">
                                                <FaUserTimes />
                                            </div>
                                            <div className="card-content">
                                                <span className="d-block fs-16 mb-5">YTD Terminated</span>
                                                <h2 className="mb-5 text-danger">{ytdTerminations}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xxl-4 col-xl-8 col-lg-8">
                                    <div className="card">
                                        <div className="card-header justify-between">
                                            <h4 className="">Recently Added Employees</h4>
                                            <a className="btn btn-primary-light btn-sm text-primary" href="/hr/all-employees">View All</a>
                                        </div>
                                        <div className="card-body pt-15">
                                            <div className="table-responsive">
                                                <table className="table tbody-b-none text-nowrap">
                                                    <thead>
                                                        <tr>
                                                            <th>Employee</th>
                                                            <th>Position</th>
                                                            <th>Department</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {recentlyAddedEmployees.map((employee, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="d-flex-items gap-10">
                                                                        <h6>{`${employee.first_name} ${employee.last_name}`}</h6>
                                                                    </div>
                                                                </td>
                                                                <td>{employee.position}</td>
                                                                <td>{employee.department?.name || employee.department || 'N/A'}</td>
                                                                <td>
                                                                    <div className="d-flex-items gap-10">
                                                                        <a className="btn-icon btn-success-light" href={`/hr/employee/${employee.id}`}>
                                                                            <RiEyeLine />
                                                                        </a>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {recentlyAddedEmployees.length === 0 && (
                                                            <tr>
                                                                <td colSpan="4" className="text-center">No recently added employees found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-xl-4 col-lg-4">
                                    <div className="d-flex flex-column">
                                        <div className="holiday-card">
                                            <h5 className="text-body text-center mb-15">Next Holiday</h5>
                                            <h3 className="text-body mb-5">{nextHoliday?.name || 'N/A'}</h3>
                                            <span className="text-body-secondary d-block">{formatDate(nextHoliday?.date)}</span>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <div className="card">
                                            {dashboardData?.employees_born_today?.length > 0 ? (
                                                <ul className="list-group list-group-flush">
                                                    {dashboardData?.employees_born_today?.map((emp) => (
                                                        <li key={emp.id} className="list-group-item d-flex align-items-center border-0 px-0">
                                                            <div className="avatar avatar-md radius-100 bg-primary-transparent text-primary me-3 text-uppercase">
                                                                {emp.first_name?.[0]}{emp.last_name?.[0]}
                                                            </div>
                                                            <div className="flex-grow-1">
                                                                <h6 className="mb-0">{emp.first_name} {emp.last_name}</h6>
                                                                <span className="text-muted fs-12">{emp.position} - {emp.department?.name || 'N/A'}</span>
                                                            </div>
                                                            <span className="badge bg-label-primary">Happy Birthday!</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <p className="text-muted mb-0">No birthdays today.</p>
                                            )}
                                        </div>

                                    </div>
                                </div>

                                <div className="col-xxl-5 col-xl-12">
                                    <div className="card">
                                        <div className="card-header justify-between">
                                            <h4 className="">Recent Notice</h4>
                                            <div className="card-dropdown">
                                                <div className="dropdown">
                                                    <span className="card-dropdown-icon" aria-expanded="false">
                                                        <FaBell />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body pt-15">
                                            <div className="announcement-list card-scrollbar">
                                                {recentNotices && recentNotices.length > 0 ? (
                                                    recentNotices.map((notice, index) => {
                                                        const colors = ['bg-primary', 'bg-secondary', 'bg-primary', 'bg-secondary', 'bg-primary'];
                                                        const color = colors[index % colors.length];
                                                        return (
                                                            <div key={notice.id || index} className="announcement-item">
                                                                <div className={`bullet ${color} mt-5`} />
                                                                <div className="announcement-content">
                                                                    <div className="announcement-header d-flex-between mb-10">
                                                                        <h5>{notice.title}</h5>
                                                                        <span className="fs-12 text-muted">{notice.created_at ? formatDate(notice.created_at) : ''}</span>
                                                                    </div>
                                                                    <p className="mb-15">{notice.content}</p>
                                                                    <div className="announcement-footer d-flex-between">
                                                                        <span className="fs-12 text-body-secondary">To: {notice.recipient_type || 'All'}</span>
                                                                        <div className="announcement-tags d-flex gap-10">
                                                                            <span className="badge bg-label-primary">{notice.recipient_type}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                ) : (
                                                    <div className="text-center py-4">
                                                        <span className="text-muted">No recent notices found</span>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="announcement-view-btn">
                                                <a href="/hr/notices" className="btn btn-primary w-100">View All Notices</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xxl-12 col-xl-12 mt-3">
                                    <div className="card">
                                        <div className="card-header justify-between">
                                            <h4 className="">Leave Request</h4>
                                            <a className="btn btn-primary-light btn-sm text-primary" href="/hr/leave-requests">View All</a>
                                        </div>
                                        <div className="card-body pt-15">
                                            <div className="table-responsive">
                                                <table className="table tbody-b-none text-nowrap">
                                                    <thead>
                                                        <tr>
                                                            <th>Employee</th>
                                                            <th>Leave Type</th>
                                                            <th>Dates</th>
                                                            <th>Duration</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {recentLeaves && recentLeaves.length > 0 ? (
                                                            recentLeaves.map((leave, index) => (
                                                                <tr key={leave.id || index}>
                                                                    <td>
                                                                        <div className="d-flex-items gap-10">
                                                                            <h6>{leave.employee_name || 'N/A'}</h6>
                                                                        </div>
                                                                    </td>
                                                                    <td>{leave.leave_type || 'Annual Leave'}</td>
                                                                    <td>{formatDate(leave.start_date)} - {formatDate(leave.end_date)}</td>
                                                                    <td>{leave.duration ? `${leave.duration} days` : 'N/A'}</td>
                                                                    <td>
                                                                        <span className={`badge ${getStatusBadgeClass(leave.status)}`}>
                                                                            {leave.status || 'Pending'}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center py-4">No recent leave requests found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                { /* app-content-area-end */}</>
        </div>
    )
}

export default HRDashboard